import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Sobre from './components/Sobre';
import Diferenciais from './components/Diferenciais';
import Curso from './components/Curso';
import Plataforma from './components/Plataforma';
import ProvasSocial from './components/ProvasSocial';
import CTAFinal from './components/CTAFinal';
import Contato from './components/Contato';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function HomePage() {
  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Sobre />
      <Diferenciais />
      <Curso />
      <Plataforma />
      <ProvasSocial />
      <CTAFinal />
      <Contato />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
